import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ModalVotacionComponent } from 'src/app/modales/modal-votacion/modal-votacion.component';
import { general } from 'src/app/models/general';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-votaciones',
  templateUrl: './votaciones.component.html',
  styleUrls: ['./votaciones.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class VotacionesComponent implements OnInit {

  private ref: undefined| DynamicDialogRef
  public agno
  public tarjeton1Visible
  public tarjeton2Visible
  public width
  public tarjetonesArray
  public label
  private tipo
  public postulados
  private tarjetonSeleccionado = 0;
  private identity
  public formVisible
  public general
  public maxVotos
  private arrayVotos = []
  private estadoPostulacion = false
  private estadoVotacion = false
  private actual = environment.actual
  public urlImg = environment.entidad[this.actual].urlEndPoint
  //private ref: DynamicDialogRef;

  constructor(
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private messageService: MessageService,
    public dialogService: DialogService,
    private route: Router) {

    this.identity = JSON.parse(this.userService.GetsessionStorage('identity'))
    let date = new Date()
    this.agno = date.getFullYear();
    this.spinner.show()
    this.general = new general()

    if (window.screen.width > 768) {
      this.width = '3'
    } else {
      console.log(window.screen.width)
      this.width = '12'
    }

    this.general.nombre = this.identity.NOMBRES
    this.general.apellido = this.identity.APELLIDOS
    this.general.correo = this.identity.EMAIL1
    this.general.cedula = parseInt(this.identity.NIT)

    console.log(this.general)

  }

  ngOnInit(): void {
    this.tarjetones()
  }

  inicio() {
    console.log(this.estadoPostulacion)

    console.log(this.estadoVotacion)
    if (this.estadoPostulacion && this.estadoVotacion) {
      if(this.ref) this.ref.close()
      this.ref = this.dialogService.open(ModalVotacionComponent, {
        //header: 'Seleccione una opcion para continuar',
        width: '30%',
        header: 'Opciones',
        data: { postulaciones: this.estadoPostulacion, votaciones: this.estadoVotacion }
      });

      this.ref.onClose.subscribe(resp => {
        if (resp == undefined) {
          //this.route.navigate(['/home']);
        } else {
          this.messageService.clear('c');
          this.tarjeton1Visible = true
          this.tipo = resp.id
          if (resp.id == 1) {
            this.label = 'Postularme'
          } else if (resp.id == 2) {
            this.label = 'Votar'
          }
        }
      });
    } else {
      this.messageService.clear('c');
      this.tarjeton1Visible = true
      if (this.estadoPostulacion) {
        this.tipo = 1
        this.label = 'Postularme'
      } else if (this.estadoVotacion) {
        this.label = 'Votar'
        this.tipo = 2
      }
    }
    //this.messageService.add({ key: 'c', sticky: true, severity: 'success', summary: 'Por favor seleccione una opcion para continuar' });
  }

  tarjetones() {
    this.tarjeton1Visible = false
    this.tarjeton2Visible = false
    this.formVisible = false
    let data = {
      nit: parseInt(this.identity.NIT)
    }
    this.userService.httpPost('tarjetones', data).subscribe(resp => {
      console.log(resp)
      this.tarjetonesArray = resp
      this.spinner.hide()
      this.tarjetonesArray.forEach(trj => {
        if (trj.Estado == 1) {
          this.estadoPostulacion = true
        }
        if (trj.Estado == 2) {
          this.estadoVotacion = true
        }
      });
      this.inicio()
      //this.messageService.add({severity:'success', summary:'Service Message', detail:'Via MessageService'});
    })
  }

  tarjeton1(id, voto, estado, max) {
    console.log(this.tipo)
    if (this.tipo == 2) {
      if (estado == 2) {
        console.log(id)
        this.tarjetonSeleccionado = id
        let data = {
          tarjeton1: id
        }
        if (!voto) {
          this.spinner.show()
          this.tarjeton1Visible = false
          this.userService.httpPost('listPostulados', data).subscribe(resp => {
            for (let i = 0; i < resp.length; i++) {
              resp[i].icon = 'pi-circle'
            }
            console.log(resp)
            this.postulados = resp
            if (resp.length > 0) {
              this.tarjeton2Visible = true
            } else {
              this.tarjeton1Visible = true
              this.messageService.add({ severity: 'info', summary: 'No hay candidatos', detail: 'No hay candidatos registrados para este tarjeton' });
            }
            this.spinner.hide()
          })
          this.maxVotos = max
        } else {
          this.messageService.add({ severity: 'error', summary: 'Voto realizado', detail: 'Señor asociado, ya se registro un voto para este tarjeton' });
        }
      } else if (estado == 1) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Señor asociado, este tarjeton se encuentra en estado de postulacion' });
      } else if (estado == 3) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Señor asociado, este tarjeton se encuentra en estado cerrado' });
      }
    } else if (this.tipo == 1) {
      if (estado == 1) {
        let data = {
          nit: parseInt(this.identity.NIT),
          id: id
        }
        this.userService.httpPost('verificaPostulacion', data).subscribe(resp => {
          if (resp.status == 'success') {
            this.general.tarjeton = id
            this.tarjeton1Visible = false
            this.formVisible = true
          } else {
            this.tarjeton1Visible = true
            this.formVisible = false
            this.messageService.add({ severity: 'error', summary: 'Postulacion realizada', detail: 'Señor asociado, ya se encuentra postulado para este tarjeton' });
          }
        })
      } else if (estado == 2) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Señor asociado, este tarjeton se encuentra en estado de votacion' });
      } else if (estado == 3) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Señor asociado, este tarjeton se encuentra en estado cerrado' });
      }
    }
  }

  accion(id) {
    if (id == 0) {
      this.inicio()
    } else {
      this.messageService.clear('c');
      this.tarjeton1Visible = true
      this.tipo = id
      if (id == 1) {
        this.label = 'Postularme'
      } else if (id == 2) {
        this.label = 'Votar'
      }
    }
  }

  agregar(cedula) {
    if (this.arrayVotos.indexOf(cedula) < 0) {
      if (this.arrayVotos.length > this.maxVotos - 1) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Señor asociado, ya cumplio con la cantidad maxima de votos para este tarjeton' });
      } else {
        this.arrayVotos.push(cedula)
        for (let i = 0; i < this.postulados.length; i++) {
          if (this.postulados[i].Cedula == cedula) {
            this.postulados[i].icon = 'pi-check-circle'
          }
        }
        this.messageService.add({ severity: 'success', summary: 'Votado', detail: 'El voto se ha seleccionado correctamente' });
      }
    } else {
      this.arrayVotos.splice(this.arrayVotos.indexOf(cedula), 1)
      for (let i = 0; i < this.postulados.length; i++) {
        if (this.postulados[i].Cedula == cedula) {
          this.postulados[i].icon = 'pi-circle'
        }
      }
    }

    console.log(this.arrayVotos)
  }

  votar() {
    if(this.arrayVotos.length > 0){
      let data = {
        candidato: this.arrayVotos,
        tarjeton: this.tarjetonSeleccionado,
        votante: parseInt(this.identity.NIT)
      }

      this.userService.httpPost('enviarVoto', data).subscribe(resp => {
        this.messageService.add(resp);
        this.arrayVotos = []
        this.tarjetones()
        this.inicio()
      })
    }else{
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar un candidato para continuar' });
    }
  }

  subida(event) {
    console.log(event)
    if (event.originalEvent.body) {
      if (event.originalEvent.body.status == 'success') {
        console.log(event.originalEvent.body)
        this.general.foto = event.originalEvent.body.filename
        this.messageService.add({ severity: 'success', summary: 'Success', detail: event.originalEvent.body.message });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: event.originalEvent.body.message });
      }
    }
  }

  guardar() {
    this.userService.httpPost('guardarPostulacion', this.general).subscribe(resp => {
      this.messageService.add(resp);
      this.tarjetones()
      //this.inicio()
    })
  }

  volver(op) {
    if (op == 1) {
      //this.inicio()
      this.tarjetones()
    } else if (op == 2) {
      this.tarjeton1Visible = true
      this.tarjeton2Visible = false
      this.formVisible = false
      this.tarjetones()
    }
  }

}
